module.exports = __webpack_public_path__ + "img/barbados.99435dbd.svg";